import { render, staticRenderFns } from "./FormBankAccount.component.vue?vue&type=template&id=3634ed40&scoped=true&"
import script from "./FormBankAccount.component.vue?vue&type=script&lang=js&"
export * from "./FormBankAccount.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3634ed40",
  null
  
)

export default component.exports